import React from 'react';
import PropTypes from 'prop-types';
import validatorHelper from '../helpers/ValidatorHelper';

const TypeProps = {
    text: 'text',
    number: 'number',
    password: 'password'
}

export default class Input extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        type: PropTypes.string,
        name: PropTypes.string,
        validationName: PropTypes.string,
        value: PropTypes.string,
        prefix: PropTypes.string,
        placeholder: PropTypes.string,
        hasBlurValidate: PropTypes.bool,

        onChange: PropTypes.func,
        onKeyDown: PropTypes.func,
        onKeyPress: PropTypes.func,

        validations: PropTypes.shape({
            isRequired: PropTypes.bool,
            min: PropTypes.number,
            max: PropTypes.number,
            phone: PropTypes.bool,
            email: PropTypes.bool
        })
    }

    static defaultProps = {
        type: TypeProps.text,
        hasBlurValidate: false,
        toggleValidate: false,
        validations: {
            isRequired: false,
            min: 0,
            max: 300,
            phone: false,
            email: false
        }
    }

    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    onBlur = (e) => {
        if (!this.props.hasBlurValidate || !this.props.validations) {
            return;
        }

        e.preventDefault();

        this.validate();
        return false;
    }

    validate = () => {
        
        const { classList } = this.ref.current;
        
        
        let validateStatus = true;
        const errors = [];

        let { value } = this.props;
        value = value.trim();
        let { validationName, name } = this.props;
        if (!validationName) {
            validationName = name;
        }
        
        const { isRequired, min, max, phone, email } = this.props.validations;
        if (isRequired) {
            if (validatorHelper.isEmpty(value)) {
                validateStatus = false;
                errors.push(`Please enter ${validationName}`);
            }
        }

         
        if (min) {
            if (validatorHelper.isLengthMoreThan(value, min)) {
                validateStatus = false;
                errors.push(`${validationName} must be more than ${min}`);
            }
        }

        if (max) {
            if (validatorHelper.isLengthLessThan(value, max)) {
                validateStatus = false;
                errors.push(`${validationName} must be less than ${max}`);
            }
        }
         
        if (phone) {
            
            if (!validatorHelper.isPhone(value)) {
                validateStatus = false;
                errors.push(`${validationName} is invalid`);
            }
        }

        if (email) {
             
            if (!validatorHelper.isEmail(value)) {
                validateStatus = false;
                errors.push(`${validationName} is invalid`);
            }
        }
        

        if (!validateStatus) {
            classList.add("error");
        }else {
            classList.remove("error");
        }
       
        return errors;
    }

    hardErr = (isError) => {
        const { classList } = this.ref.current;
        // console.log(classList);
        if (isError) {
            classList.add("error");
        }else {
            classList.remove("error");
        }
        
    }

    render() {
        const { value, name, placeholder, onChange, hasBlurValidate, type, onKeyDown, onKeyPress} = this.props;
        const {min, max }= this.props.validations;
        
        return (
            <input ref={this.ref} name={name} className="ladiui input"  placeholder={placeholder} value={value} onChange={onChange} onBlur={this.onBlur} type={type} onKeyDown={onKeyDown} min={min} max={max}
            onKeyPress={onKeyPress}/>
        );
    }
}
